(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-hero-media"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.currentScript?.closest('.shopify-section') || document;

    root.querySelectorAll('.cusotm-hero-media__video-control').forEach((button) => {
      if (button.dataset.cusotmBound === 'true') return;
      button.dataset.cusotmBound = 'true';

      button.addEventListener('click', () => {
        const wrapper = button.closest('.cusotm-hero-media__breakpoint');
        const video = wrapper?.querySelector('.cusotm-hero-media__video');
        if (!video) return;

        if (video.paused) {
          video.play();
          button.textContent = 'Ⅱ';
          button.setAttribute('aria-label', 'Video pausieren');
        } else {
          video.pause();
          button.textContent = '▶';
          button.setAttribute('aria-label', 'Video abspielen');
        }
      });
    });

    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.cusotm-hero-media__video').forEach((video) => video.pause());
      root.querySelectorAll('.cusotm-hero-media__video-control').forEach((button) => {
        button.textContent = '▶';
        button.setAttribute('aria-label', 'Video abspielen');
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    if (!window.__finkidCookiePreferencesTriggerBound) {
    window.__finkidCookiePreferencesTriggerBound = true;

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-cookie-preferences-trigger]');

      if (!trigger) {
        return;
      }

      event.preventDefault();

      if (typeof showPreferences === 'function') {
        showPreferences();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class TabsBlock extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.isDesignMode = (this.dataset.designMode === 'true');

    this.tablist = this.querySelector('[role="tablist"]');
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (!this.tablist || this.tabs.length === 0 || this.panels.length === 0) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        this.activate(i, true);
        if (this.isDesignMode) {
          this.panels[i]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
    });

    // Default active
    this.activate(0, false);

    // Shopify editor: selecting any block inside a hidden panel opens the correct tab
    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event?.detail?.blockId;
      if (!blockId) return;

      const el = document.querySelector(`[data-shopify-editor-block-id="${blockId}"]`);
      if (!el) return;

      const idx = this.panels.findIndex((p) => p.contains(el));
      if (idx >= 0) this.activate(idx, false);
    });
  }

  onKeydown(event, currentIndex) {
    const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (!keys.includes(event.key)) return;

    event.preventDefault();

    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    this.activate(nextIndex, true);
  }

  activate(index, focus) {
    this.tabs.forEach((tab, i) => {
      const selected = (i === index);

      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;

      // Active = primary, inactive = secondary
      tab.classList.toggle('button', selected);
      tab.classList.toggle('button-secondary', !selected);
    });

    this.panels.forEach((panel, i) => {
      if (i === index) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });

    if (focus) this.tabs[index]?.focus();
  }
}

if (!customElements.get('tabs-block')) {
  customElements.define('tabs-block', TabsBlock);
}
  } catch(e) { console.error(e); }
})();

})();
